/**
 * Check if a given object implements the StripeProductBoardUpdateTemplate interface.
 */
export function instanceOfStripeProductBoardUpdateTemplate(value) {
    let isInstance = true;
    isInstance = isInstance && "productIds" in value;
    isInstance = isInstance && "description" in value;
    return isInstance;
}
export function StripeProductBoardUpdateTemplateFromJSON(json) {
    return StripeProductBoardUpdateTemplateFromJSONTyped(json, false);
}
export function StripeProductBoardUpdateTemplateFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'productIds': json['productIds'],
        'description': json['description'],
    };
}
export function StripeProductBoardUpdateTemplateToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'productIds': value.productIds,
        'description': value.description,
    };
}
